// src/components/ContactPage.jsx
import React from "react";
import { FiCopy, FiMail } from "react-icons/fi";

const contactEmails = [
  {
    title: "Umumiy savollar",
    desc: "Platforma va foydalanish haqidagi umumiy savollar uchun",
    email: "hello@livequiz.uz",
  },
  {
    title: "Marketing va hamkorlik",
    desc: "Hamkorlik va marketing masalalari uchun",
    email: "marketing@livequiz.uz",
  },
  {
    title: "Texnik yordam",
    desc: "Texnik savollar va yordam uchun",
    email: "support@livequiz.uz",
  },
];

export default function ContactPage() {
  const handleCopy = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).catch(() => {});
    }
  };

  return (
    <section className="bg-white py-16 sm:py-20">
      <div className="max-w-6xl mx-auto px-4">
        {/* Title + subtitle */}
        <div className="text-center mb-14">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900">
            Biz bilan bog&apos;laning
          </h1>
          <p className="mt-3 text-sm sm:text-base text-gray-500 max-w-2xl mx-auto">
            Savollaringiz bormi? Biz har doim yordam berishga tayyormiz.
            Biz bilan qulay usulda bog&apos;laning.
          </p>
        </div>

        {/* 2-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* LEFT: contact cards */}
          <div className="space-y-6">
            <div className="rounded-3xl border border-gray-200 bg-white shadow-sm p-6 sm:p-8">
              <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">
                Bizning kontaktlar
              </h2>
              <p className="text-sm text-gray-500 mb-6">
                Bizga to‘g‘ridan-to‘g‘ri elektron pochta orqali yozing
              </p>

              <div className="divide-y divide-gray-200">
                {contactEmails.map((item) => (
                  <div
                    key={item.email}
                    className="flex items-start justify-between py-4"
                  >
                    <div className="flex items-start gap-3 pr-4">
                      <span className="mt-2 h-2 w-2 rounded-full bg-black" />
                      <div>
                        <h3 className="text-sm font-semibold text-gray-900">
                          {item.title}
                        </h3>
                        <p className="mt-1 text-xs sm:text-sm text-gray-500">
                          {item.desc}
                        </p>
                      </div>
                    </div>

                    <button
                      type="button"
                      onClick={() => handleCopy(item.email)}
                      className="flex items-center gap-2 text-xs sm:text-sm text-gray-700 hover:text-gray-900"
                    >
                      <span>{item.email}</span>
                      <FiCopy className="h-4 w-4" />
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* quick reply card */}
            <div className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 sm:p-5 flex items-start gap-3">
              <div className="mt-1">
                <FiMail className="h-5 w-5 text-gray-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Tezkor javob
                </p>
                <p className="mt-1 text-xs sm:text-sm text-gray-500">
                  Biz ish kunlarida odatda 24 soat ichida xatlaringizga javob
                  beramiz.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT: form */}
          <div className="rounded-3xl border border-gray-200 bg-white shadow-sm p-6 sm:p-8">
            
            <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">
              Xabar yuborish
            </h2>
            <p className="text-sm text-gray-500 mb-6">
              Formani to‘ldiring, biz siz bilan 24 soat ichida bog‘lanamiz
            </p>

            <form
              className="space-y-4"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              {/* Name + Email */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    ISM <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Sizning to‘liq ismingiz"
                    className="block w-full rounded-xl border-gray-200 text-sm px-3 py-2.5 bg-gray-50 focus:bg-white focus:border-black focus:ring-black"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    EMAIL <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    placeholder="sizning@email.com"
                    className="block w-full rounded-xl border-gray-200 text-sm px-3 py-2.5 bg-gray-50 focus:bg-white focus:border-black focus:ring-black"
                    required
                  />
                </div>
              </div>

              {/* Company + Telegram */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    KOMPANIYA
                  </label>
                  <input
                    type="text"
                    placeholder="Kompaniyangiz nomi"
                    className="block w-full rounded-xl border-gray-200 text-sm px-3 py-2.5 bg-gray-50 focus:bg-white focus:border-black focus:ring-black"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    TELEGRAM
                  </label>
                  <input
                    type="text"
                    placeholder="@foydalanuvchi"
                    className="block w-full rounded-xl border-gray-200 text-sm px-3 py-2.5 bg-gray-50 focus:bg-white focus:border-black focus:ring-black"
                  />
                </div>
              </div>

              {/* Subject */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  MAVZU
                </label>
                <input
                  type="text"
                  placeholder="Savolingizning qisqacha tavsifi"
                  className="block w-full rounded-xl border-gray-200 text-sm px-3 py-2.5 bg-gray-50 focus:bg-white focus:border-black focus:ring-black"
                />
              </div>

              {/* Message */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  XABAR <span className="text-red-500">*</span>
                </label>
                <textarea
                  rows={4}
                  placeholder="Savolingiz yoki taklifingizni batafsil yozing..."
                  className="block w-full rounded-xl border-gray-200 text-sm px-3 py-2.5 bg-gray-50 focus:bg-white focus:border-black focus:ring-black resize-none"
                  required
                />
              </div>

              {/* Submit */}
              <div className="pt-3">
                <button
                  type="submit"
                  className="w-full sm:w-auto px-8 py-3 rounded-full bg-black text-white text-sm font-medium flex items-center justify-center gap-2 hover:bg-gray-900 transition"
                >
                  Xabar yuborish
                  <span className="text-lg">➜</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
